import { CoatingBodySize, CoatingPolishOption } from '@/types/api/coatingApi';

export const coatingSteps = {
  PRE_SELECTION: 1,
  REGISTATION: 2,
  ADDITIONAL_INFO: 3,
  REVIEW: 4,
} as const;

export const coatingServiceType = 'coating' as const;

/** 決済方法 */
export const coatingPaymentMethod = {
  CREDIT_CARD: 'credit_card',
  PAIDY: 'paidy',
} as const;

export type CoatingPaymentMethod =
  typeof coatingPaymentMethod[keyof typeof coatingPaymentMethod];

export const coatingBodySizes = {
  SEDAN: 1,
  SUV_MPV: 2,
} as const;

export const coatingPolishOptions = {
  NONE: 0,
  MIN_60: 1,
  MIN_150: 2,
} as const;

export const coatingBodySizeOptions: {
  label: string;
  value: CoatingBodySize;
}[] = [
  {
    label: 'Sedan（セダン・コンパクト等）',
    value: coatingBodySizes.SEDAN,
  },
  {
    label: 'SUV / MPV（SUV・ミニバン等）',
    value: coatingBodySizes.SUV_MPV,
  },
];

export const coatingPolishOptionOptions: {
  label: string;
  value: CoatingPolishOption;
}[] = [
  {
    label: '磨き無し（新車向け）',
    value: coatingPolishOptions.NONE,
  },
  {
    label: '60分磨き（既販車3年未満）',
    value: coatingPolishOptions.MIN_60,
  },
  {
    label: '150分磨き（既販車3年以上）',
    value: coatingPolishOptions.MIN_150,
  },
];

export const coatingMarginTypes = {
  NONE: 3,
  YES: 1,
  NARROW_GAP: 2,
} as const;

export const coatingScratchedChecks = {
  AVAILABLE: 1,
  NOT_AVAILABLE: 2,
} as const;

export const coatingSecuritySystems = {
  YES: 1,
  NO: 2,
  UNKNOWN: 9,
} as const;

export const coatingCancellationFrom = {
  USER: 1,
  OPERATOR: 2,
} as const;

export const coatingCancellationType = {
  ANOTHER_APPOINTMENT: 4,
  NO_NEED: 5,
  CAR_DISPOSED: 8,
  OTHER_VENDOR: 9,
  BUDGET: 10,
  OTHER: 7,
} as const;

export const coatingCancellationTypeOptions = [
  {
    value: coatingCancellationType.ANOTHER_APPOINTMENT,
    text: '都合が悪くなってしまった',
    detail: '別の予定が入った',
  },
  {
    value: coatingCancellationType.CAR_DISPOSED,
    text: '車を手放すことにした',
    detail: '売却・買い替え・事故等で対象車両がなくなる',
  },
  {
    value: coatingCancellationType.OTHER_VENDOR,
    text: '別の業者で施工することにした',
    detail: '他業者へ依頼',
  },
  {
    value: coatingCancellationType.BUDGET,
    text: '予算の都合がつかなくなった',
    detail: '価格を再検討',
  },
  {
    value: coatingCancellationType.NO_NEED,
    text: 'コーティングをしないことにした',
    detail: 'サービスが不要になった',
  },
  {
    value: coatingCancellationType.OTHER,
    text: 'その他',
    detail: '',
  },
];

/** 予約締切日数（今日から何日後以降を選択可能とするか） */
export const COATING_MIN_DAYS_AHEAD = 10;

/**
 * キャンセル料スケジュール
 * 施工日までの残り日数（daysAhead）に応じて適用される率（percent）
 * daysAhead = 0 は当日
 *
 * 段階:
 *   - 9日前〜4日前: 10%
 *   - 3日前〜前日:  30%
 *   - 当日:         100%
 */
export const COATING_CANCELLATION_CHARGE_SCHEDULE = [
  { minDaysAhead: 4, maxDaysAhead: 9, percent: 10, label: '9日前〜4日前' },
  { minDaysAhead: 1, maxDaysAhead: 3, percent: 30, label: '3日前〜前日' },
  { minDaysAhead: 0, maxDaysAhead: 0, percent: 100, label: '当日' },
];

/**
 * ウィンドウコーティング系オプション名キーワード
 * このキーワードを含むオプションは排他選択（1つだけ選択可能）
 */
export const COATING_WINDOW_OPTION_KEYWORDS = ['ウィンドウコーティング'];

/**
 * 磨き必須メーカー
 * 該当メーカーの車両はBRILA RED LINE固定 + 磨き無し選択不可
 */
export const COATING_POLISH_REQUIRED_MAKERS = [
  'ニッサン',
  '日産',
  'NISSAN',
  'ホンダ',
  'HONDA',
];

/**
 * RED LINE のコーティングアイテムコード
 */
export const COATING_RED_LINE_CODE = '23';
